import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  Alert
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const FixedWingCumulativeLimits = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Additional Cumulative Limits (Para 9)</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            Additional cumulative flight time and duty period limitations based on D7J-J4-Fixed Wing.pdf Para 9.
          </Typography>
        </Alert>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Duty Period (7 Days)"
              type="number"
              value={baseline.maxDutyPeriod7Days}
              onChange={(e) => handleChange('maxDutyPeriod7Days', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 100, step: 0.5 }}
              helperText="Para 9.1: 60 hrs"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Flight Time (14 Days)"
              type="number"
              value={baseline.maxFlightTime14Days}
              onChange={(e) => handleChange('maxFlightTime14Days', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 100, step: 0.5 }}
              helperText="Para 9.2: 65 hrs"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Duty Period (14 Days)"
              type="number"
              value={baseline.maxDutyPeriod14Days}
              onChange={(e) => handleChange('maxDutyPeriod14Days', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 200, step: 0.5 }}
              helperText="Para 9.2: 100 hrs"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Duty Period (28 Days)"
              type="number"
              value={baseline.maxDutyPeriod28Days}
              onChange={(e) => handleChange('maxDutyPeriod28Days', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 300, step: 0.5 }}
              helperText="Para 9.3: 190 hrs"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Flight Time (90 Days)"
              type="number"
              value={baseline.maxFlightTime90Days}
              onChange={(e) => handleChange('maxFlightTime90Days', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 500, step: 0.5 }}
              helperText="Para 9.4: 300 hrs"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Duty Period (90 Days)"
              type="number"
              value={baseline.maxDutyPeriod90Days}
              onChange={(e) => handleChange('maxDutyPeriod90Days', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 1000, step: 0.5 }}
              helperText="Para 9.4: 600 hrs"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default FixedWingCumulativeLimits;
